import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=4603cddf&scoped=true&"
import script from "./addModal.vue?vue&type=script&lang=js&"
export * from "./addModal.vue?vue&type=script&lang=js&"
import style0 from "./addModal.vue?vue&type=style&index=0&id=4603cddf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603cddf",
  null
  
)

export default component.exports